import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common.service';
import { UpdateClaimNoteModalComponent } from '../update-claim-note-modal/update-claim-note-modal.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ClaimService } from '../../services/claim.service';

@Component({
  selector: 'fury-notes-table',
  templateUrl: './notes-table.component.html',
  styleUrls: ['./notes-table.component.scss']
})
export class NotesTableComponent implements OnInit {

  ngUnsubscribe = new Subject<void>();
  @Input() displayedColumns: any[];
  @Input() dataSource: any[] = [];
  @Input() fileClaimId: string = '';
  @Input() fileClaimNumber: string = '';

  constructor(
    public commonService: CommonService,
    private dialog: MatDialog,
    private claimService: ClaimService
  ) { }

  ngOnInit(): void {
  }
  handleNotes(type: string, rowData?: any) {
    this.dialog
      .open(UpdateClaimNoteModalComponent, {
        width: "800px",
        panelClass: "payment-info",
        data: { type, rowData, fileClaimId: this.fileClaimId, fileClaimNumber: this.fileClaimNumber },
      })
      .afterClosed()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: any) => {
        if (res) {
        this.claimService.setFetchClaimNote(true);
        }
      });
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
